module.exports = __webpack_public_path__ + "img/welcome-dashboard-2.18549555.png";